import { Locale } from '@/utility/locale';

export const getPromoKey = (slotId: string | null, locale: Locale) =>
  ['promoBanner', slotId, locale] as const;

export const getPromoBaseConfig = (slotId: string | null) => ({
  enabled: slotId !== null,
  retry: false,
});
